import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import { truncateSplitCharacters } from '@Utils/String';

import './QuickResultsHeading.scss';

const MAX_QUERY_LENGTH = 100;

function QuickResultsHeading(props) {
  const { isQueryEnabled, query, structurePreview, goToNewSearch, goToEditSearch, showStructurePopup } = props;

  const handleSearchStructureButtonClick = () => {
    showStructurePopup(structurePreview);
  };

  return (
    <div className="quick-results-heading e2e-quick-results-heading">
      <div className="quick-results-heading__wrapper">
        {!isQueryEnabled && (
          <div className="quick-results-heading__emptyTitle">
            <h1 className="quick-results-heading__emptyTitle_label">No Query Available </h1>
            <span className="quick-results-heading__emptyTitle_description">Please enter a query</span>
          </div>
        )}

        {isQueryEnabled && (
          <div className="quick-results-heading__title">
            <h1 className="quick-results-heading__title_label">
              <span className="quick-results-heading__title_label-grey">Results for</span>
              {query && <span>{truncateSplitCharacters(query, MAX_QUERY_LENGTH)}</span>}
              {query && structurePreview && <span>AND</span>}
              {structurePreview && (
                <Button
                  type="button"
                  tabIndex="0"
                  onClick={handleSearchStructureButtonClick}
                  buttonConfig={{
                    type: 'tertiary',
                    size: 'md',
                    iconOnly: true,
                    e2eName: 'query-results-heading-showStructure',
                    areaLabel: 'Show quick results structure',
                  }}
                  iconConfig={{
                    name: 'structure',
                    size: 'sm',
                  }}
                />
              )}
            </h1>
          </div>
        )}
        {isQueryEnabled && (
          <div className="quick-results-heading__buttons">
            <Button
              type="button"
              tabIndex="0"
              onClick={goToNewSearch}
              buttonConfig={{
                type: 'link',
                size: 'sm',
                iconOnly: true,
                e2eName: 'query-results-heading-new',
                areaLabel: 'Create new quick search',
                label: 'New',
              }}
              iconConfig={{
                name: 'refresh',
                size: 'sm',
              }}
            />

            <Button
              type="button"
              tabIndex="0"
              onClick={goToEditSearch}
              buttonConfig={{
                type: 'link',
                size: 'sm',
                iconOnly: true,
                e2eName: 'query-results-heading-edit',
                areaLabel: 'Edit quick search',
                label: 'Edit',
              }}
              iconConfig={{
                name: 'pencil',
                size: 'sm',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

QuickResultsHeading.propTypes = {
  isQueryEnabled: PropTypes.bool,
  query: PropTypes.string,
  structurePreview: PropTypes.object,
  goToNewSearch: PropTypes.func.isRequired,
  goToEditSearch: PropTypes.func.isRequired,
  showStructurePopup: PropTypes.func.isRequired,
};

export default QuickResultsHeading;
